export const contactBlurb =
  'LAEBEL is the factory of the KAYS & KAYS ecosystem, headquartered in Dubai. Studios, Ventures and Labs — one source of origin.'
